<template>
  <v-app class="d-flex flex-column">
    <router-view />
    <GlobalSnackbar />
  </v-app>
</template>

<script>
import GlobalSnackbar from './components/GlobalSnackbar.vue'

export default {
  name: 'App',
  components: {
    GlobalSnackbar,
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Cal+Sans&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Outfit&display=swap');
  .cal-sans-regular {
    font-family: "Cal Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .outfit-regular {
    font-family: "Outfit", sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .main-content {
    background: #f3f3f3;
    background: url('./assets/dot-grid.webp') repeat;
    overflow: auto;
    padding: 0 !important;
  }
  .main-content-dark {
    background: #121212;
    background: url('./assets/dot-grid-dark.webp') repeat !important;
    overflow: auto;
    padding: 0 !important;
  }
  .width-auto {
    width: auto;
  }
  .width-100 {
    width: 100%;
  }
  .height-100 {
    height: 100%;
  }
  .height-2 {
    height: 2px;
  }
  .position-absolute {
    position: absolute;
  }
  .position-relative {
    position: relative;
  }
  .left-0 {
    left: 0;
  }
  .right-0 {
    right: 0;
  }
  .top-0 {
    top: 0;
  }
  .bottom-0 {
    bottom: 0;
  }
  $sizes: 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30;
  @each $size in $sizes {
    .font-size-#{$size} {
      font-size: #{$size}px;
    }
  }
  .flex-none {
    flex: none !important;
    overflow: auto;
  }
  .flex-1 {
    flex: 1 !important;
    overflow: hidden;
  }
  .flex-2 {
    flex: 2 !important;
    overflow: auto;
  }
  .flex-3 {
    flex: 3 !important;
    overflow: auto;
  }
  .align-self-center {
    align-self: center !important;
  }
  .ideaverse-black--background {
    background: #181818 !important;
  }
  .ideaverse-black-accent--background {
    background: #212121 !important;
  }
  .ideaverse-black--text {
    color: #181818 !important;
  }
  .ideaverse-black-accent--text {
    color: #212121 !important;
  }
  .ideaverse-black-highlight--background {
    background: #2b2b2b !important;
  }
  .background-none {
    background: none !important;
  }
</style>